"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.surveyConfigurationFetchResponseReset = exports.surveyConfigurationFetchResponse = exports.recipientUpdate = exports.recipientUnlockBulk = exports.recipientUnlock = exports.recipientUniqueReferenceNoReset = exports.recipientUniqueReferenceNo = exports.recipientUniqueMailReset = exports.recipientUniqueMail = exports.recipientSuccess = exports.recipientSubmitBulk = exports.recipientSubmit = exports.recipientStatusUnpagedList = exports.recipientSoftDeleteList = exports.recipientSoftDeleteBulk = exports.recipientSoftDelete = exports.recipientSetFundIdList = exports.recipientSaveLinkedFundReset = exports.recipientSaveLinkedFund = exports.recipientRestoreBulk = exports.recipientRestore = exports.recipientReset = exports.recipientPrefight = exports.recipientLockBulk = exports.recipientLock = exports.recipientListSearch = exports.recipientListLink = exports.recipientList = exports.recipientLinkedFundReset = exports.recipientLinkedFund = exports.recipientLinkSurveyAndRecipientResponseReset = exports.recipientLinkSurveyAndRecipientResponse = exports.recipientLinkSingleSoftDeleteBulk = exports.recipientLinkSingleSoftDelete = exports.recipientImport = exports.recipientGetSurveyRecipentResponse = exports.recipientErrorSheetDownload = exports.recipientError = exports.recipientDownloadSurveyResponse = exports.recipientDownloadAll = exports.recipientDownload = exports.recipientDeleteBulk = exports.recipientDelete = exports.recipientCreate = exports.recipientCopyUrl = exports.recipientCheckSurvey = exports.recipientCheckRecipient = exports.recipientApproveBulk = exports.recipientApprove = void 0;
var _recipient = require("./recipient.constant");
// @flow

// common success
var recipientSuccess = function recipientSuccess(actionType, data) {
  return {
    type: _recipient.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.recipientSuccess = recipientSuccess;
var recipientError = function recipientError(actionType, error) {
  return {
    type: _recipient.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * recipient reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.recipientError = recipientError;
var recipientReset = function recipientReset(data) {
  return {
    type: _recipient.actionTypes.RESET,
    payload: data
  };
};

/**
 * recipient unique reference no
 * @param payload
 * @returns api response
 * @description this function used to get unique reference no of recipient.
 */
exports.recipientReset = recipientReset;
var recipientUniqueReferenceNo = function recipientUniqueReferenceNo(data) {
  return {
    type: _recipient.actionTypes.UNIQUE_REFERENCE_NO,
    payload: data
  };
};

/**
 * recipient unique reference no reset
 * @param payload
 * @returns api response
 * @description this function used to get unique reference no of recipient.
 */
exports.recipientUniqueReferenceNo = recipientUniqueReferenceNo;
var recipientUniqueReferenceNoReset = function recipientUniqueReferenceNoReset(data) {
  return {
    type: _recipient.actionTypes.UNIQUE_REFERENCE_NO_RESET,
    payload: data
  };
};

/**
 * recipient unique reference no
 * @param payload
 * @returns api response
 * @description this function used to get unique reference no of recipient.
 */
exports.recipientUniqueReferenceNoReset = recipientUniqueReferenceNoReset;
var recipientUniqueMail = function recipientUniqueMail(data) {
  return {
    type: _recipient.actionTypes.UNIQUE_MAIL,
    payload: data
  };
};

/**
 * recipient unique reference no reset
 * @param payload
 * @returns api response
 * @description this function used to get unique reference no of recipient.
 */
exports.recipientUniqueMail = recipientUniqueMail;
var recipientUniqueMailReset = function recipientUniqueMailReset(data) {
  return {
    type: _recipient.actionTypes.UNIQUE_MAIL_RESET,
    payload: data
  };
};

/**
 * List
 * @param payload
 * @returns api response
 * @description this function used to List.
 */
exports.recipientUniqueMailReset = recipientUniqueMailReset;
var recipientList = function recipientList(data) {
  return {
    type: _recipient.actionTypes.LIST,
    payload: data
  };
};

/**
 * List
 * @param payload
 * @returns api response
 * @description this function used to List.
 */
exports.recipientList = recipientList;
var recipientListLink = function recipientListLink(data) {
  return {
    type: _recipient.actionTypes.LIST_LINK,
    payload: data
  };
};

/**
 * List
 * @param payload
 * @returns api response
 * @description this function used to List.
 */
exports.recipientListLink = recipientListLink;
var recipientListSearch = function recipientListSearch(data) {
  return {
    type: _recipient.actionTypes.LIST_SEARCH,
    payload: data
  };
};

/**
 * Create
 * @param payload
 * @returns api response
 * @description this function used to Create.
 */
exports.recipientListSearch = recipientListSearch;
var recipientCreate = function recipientCreate(data) {
  return {
    type: _recipient.actionTypes.CREATE,
    payload: data
  };
};

/**
 * Create
 * @param payload
 * @returns api response
 * @description this function used to Create.
 */
exports.recipientCreate = recipientCreate;
var recipientSetFundIdList = function recipientSetFundIdList(data) {
  return {
    type: _recipient.actionTypes.SET_FUND_ID_LIST,
    payload: data
  };
};

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to Update.
 * @param data
 */
exports.recipientSetFundIdList = recipientSetFundIdList;
var recipientUpdate = function recipientUpdate(data) {
  return {
    type: _recipient.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Linked Fund.
 */
exports.recipientUpdate = recipientUpdate;
var recipientLinkedFund = function recipientLinkedFund(data) {
  return {
    type: _recipient.actionTypes.LINKED_FUND,
    payload: data
  };
};

/**
 * Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Linked Fund reset.
 */
exports.recipientLinkedFund = recipientLinkedFund;
var recipientLinkedFundReset = function recipientLinkedFundReset(data) {
  return {
    type: _recipient.actionTypes.LINKED_FUND_RESET,
    payload: data
  };
};

/**
 * Save Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Save Linked Fund.
 */
exports.recipientLinkedFundReset = recipientLinkedFundReset;
var recipientSaveLinkedFund = function recipientSaveLinkedFund(data) {
  return {
    type: _recipient.actionTypes.SAVE_LINKED_FUND,
    payload: data
  };
};

/**
 * Save Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Save Linked Fund.
 */
exports.recipientSaveLinkedFund = recipientSaveLinkedFund;
var recipientSaveLinkedFundReset = function recipientSaveLinkedFundReset(data) {
  return {
    type: _recipient.actionTypes.SAVE_LINKED_FUND_RESET,
    payload: data
  };
};

/**
 * Lock
 * @param payload
 * @returns api response
 * @description this function used to Lock.
 */
exports.recipientSaveLinkedFundReset = recipientSaveLinkedFundReset;
var recipientLock = function recipientLock(data) {
  return {
    type: _recipient.actionTypes.LOCK,
    payload: data
  };
};

/**
 * Lock Bulk
 * @param payload
 * @returns api response
 * @description this function used to Lock Bulk.
 */
exports.recipientLock = recipientLock;
var recipientLockBulk = function recipientLockBulk(data) {
  return {
    type: _recipient.actionTypes.LOCK_BULK,
    payload: data
  };
};

/**
 * Unlock
 * @param payload
 * @returns api response
 * @description this function used to Unlock.
 */
exports.recipientLockBulk = recipientLockBulk;
var recipientUnlock = function recipientUnlock(data) {
  return {
    type: _recipient.actionTypes.UNLOCK,
    payload: data
  };
};

/**
 * Unlock Bulk
 * @param payload
 * @returns api response
 * @description this function used to Unlock Bulk.
 */
exports.recipientUnlock = recipientUnlock;
var recipientUnlockBulk = function recipientUnlockBulk(data) {
  return {
    type: _recipient.actionTypes.UNLOCK_BULK,
    payload: data
  };
};

/**
 * Soft Delete
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete.
 */
exports.recipientUnlockBulk = recipientUnlockBulk;
var recipientSoftDelete = function recipientSoftDelete(data) {
  return {
    type: _recipient.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * Soft Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete Bulk.
 */
exports.recipientSoftDelete = recipientSoftDelete;
var recipientSoftDeleteBulk = function recipientSoftDeleteBulk(data) {
  return {
    type: _recipient.actionTypes.SOFT_DELETE_BULK,
    payload: data
  };
};

/**
 * Submit
 * @param payload
 * @returns api response
 * @description this function used to Submit.
 */
exports.recipientSoftDeleteBulk = recipientSoftDeleteBulk;
var recipientSubmit = function recipientSubmit(data) {
  return {
    type: _recipient.actionTypes.SUBMIT,
    payload: data
  };
};

/**
 * Submit Bulk
 * @param payload
 * @returns api response
 * @description this function used to Submit Bulk.
 */
exports.recipientSubmit = recipientSubmit;
var recipientSubmitBulk = function recipientSubmitBulk(data) {
  return {
    type: _recipient.actionTypes.SUBMIT_BULK,
    payload: data
  };
};

/**
 * Approve
 * @param payload
 * @returns api response
 * @description this function used to Approve.
 */
exports.recipientSubmitBulk = recipientSubmitBulk;
var recipientApprove = function recipientApprove(data) {
  return {
    type: _recipient.actionTypes.APPROVE,
    payload: data
  };
};

/**
 * Approve Bulk
 * @param payload
 * @returns api response
 * @description this function used to Approve Bulk.
 */
exports.recipientApprove = recipientApprove;
var recipientApproveBulk = function recipientApproveBulk(data) {
  return {
    type: _recipient.actionTypes.APPROVE_BULK,
    payload: data
  };
};

/**
 * Copy Url
 * @param payload
 * @returns api response
 * @description this function used to Copy Url.
 */
exports.recipientApproveBulk = recipientApproveBulk;
var recipientCopyUrl = function recipientCopyUrl(data) {
  return {
    type: _recipient.actionTypes.COPY_URL,
    payload: data
  };
};

/**
 * Download
 * @param payload
 * @returns api response
 * @description this function used to Download.
 */
exports.recipientCopyUrl = recipientCopyUrl;
var recipientDownload = function recipientDownload(data) {
  return {
    type: _recipient.actionTypes.DOWNLOAD,
    payload: data
  };
};

/**
 * Download All
 * @param payload
 * @returns api response
 * @description this function used to Download All.
 */
exports.recipientDownload = recipientDownload;
var recipientDownloadAll = function recipientDownloadAll(data) {
  return {
    type: _recipient.actionTypes.DOWNLOAD_ALL,
    payload: data
  };
};

/**
 * Download Survey Response
 * @param payload
 * @returns api response
 * @description this function used to Download Survey Response.
 */
exports.recipientDownloadAll = recipientDownloadAll;
var recipientDownloadSurveyResponse = function recipientDownloadSurveyResponse(data) {
  return {
    type: _recipient.actionTypes.DOWNLOAD_SURVEY_RESPONSE,
    payload: data
  };
};

// DELETED DATA

/**
 * Soft Delete List
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete List.
 */
exports.recipientDownloadSurveyResponse = recipientDownloadSurveyResponse;
var recipientSoftDeleteList = function recipientSoftDeleteList(data) {
  return {
    type: _recipient.actionTypes.SOFT_DELETE_LIST,
    payload: data
  };
};

/**
 * Restore
 * @param payload
 * @returns api response
 * @description this function used to Restore.
 */
exports.recipientSoftDeleteList = recipientSoftDeleteList;
var recipientRestore = function recipientRestore(data) {
  return {
    type: _recipient.actionTypes.RESTORE,
    payload: data
  };
};

/**
 * Restore Bulk
 * @param payload
 * @returns api response
 * @description this function used to Restore Bulk.
 */
exports.recipientRestore = recipientRestore;
var recipientRestoreBulk = function recipientRestoreBulk(data) {
  return {
    type: _recipient.actionTypes.RESTORE_BULK,
    payload: data
  };
};

/**
 * Delete
 * @param payload
 * @returns api response
 * @description this function used to Delete.
 */
exports.recipientRestoreBulk = recipientRestoreBulk;
var recipientDelete = function recipientDelete(data) {
  return {
    type: _recipient.actionTypes.DELETE,
    payload: data
  };
};

/**
 * Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Delete Bulk.
 */
exports.recipientDelete = recipientDelete;
var recipientDeleteBulk = function recipientDeleteBulk(data) {
  return {
    type: _recipient.actionTypes.DELETE_BULK,
    payload: data
  };
};

// Uploader

/**
 * Prefight
 * @param payload
 * @returns api response
 * @description this function used to Prefight.
 */
exports.recipientDeleteBulk = recipientDeleteBulk;
var recipientPrefight = function recipientPrefight(data) {
  return {
    type: _recipient.actionTypes.PREFIGHT,
    payload: data
  };
};

/**
 * Import
 * @param payload
 * @returns api response
 * @description this function used to Import.
 */
exports.recipientPrefight = recipientPrefight;
var recipientImport = function recipientImport(data) {
  return {
    type: _recipient.actionTypes.IMPORT,
    payload: data
  };
};

/**
 * Error Sheet Download
 * @param payload
 * @returns api response
 * @description this function used to Error Sheet Download.
 */
exports.recipientImport = recipientImport;
var recipientErrorSheetDownload = function recipientErrorSheetDownload(data) {
  return {
    type: _recipient.actionTypes.ERROR_SHEET_DOWNLOAD,
    payload: data
  };
};

/**
 * Get Survey Recipent Response
 * @param payload
 * @returns api response
 * @description this function used to Get Survey Recipent Response.
 */
exports.recipientErrorSheetDownload = recipientErrorSheetDownload;
var recipientGetSurveyRecipentResponse = function recipientGetSurveyRecipentResponse(data) {
  return {
    type: _recipient.actionTypes.GET_SURVEY_RECIPENT_RESPONSE,
    payload: data
  };
};

// Link

/**
 * Check Recipient
 * @param payload
 * @returns api response
 * @description this function used to Check Recipient.
 */
exports.recipientGetSurveyRecipentResponse = recipientGetSurveyRecipentResponse;
var recipientCheckRecipient = function recipientCheckRecipient(data) {
  return {
    type: _recipient.actionTypes.CHECK_RECIPIENT,
    payload: data
  };
};

/**
 * Check Survey
 * @param payload
 * @returns api response
 * @description this function used to Check Survey.
 */
exports.recipientCheckRecipient = recipientCheckRecipient;
var recipientCheckSurvey = function recipientCheckSurvey(data) {
  return {
    type: _recipient.actionTypes.CHECK_SURVEY,
    payload: data
  };
};

/**
 * Link Survey And Recipient Response
 * @param payload
 * @returns api response
 * @description this function used to Link Survey And Recipient Response.
 */
exports.recipientCheckSurvey = recipientCheckSurvey;
var recipientLinkSurveyAndRecipientResponse = function recipientLinkSurveyAndRecipientResponse(data) {
  return {
    type: _recipient.actionTypes.LINK_SURVEY_AND_RECIPIENT_RESPONSE,
    payload: data
  };
};

/**
 * Link Survey And Recipient Response reset
 * @param payload
 * @returns api response
 * @description this function used to Link Survey And Recipient Response.
 */
exports.recipientLinkSurveyAndRecipientResponse = recipientLinkSurveyAndRecipientResponse;
var recipientLinkSurveyAndRecipientResponseReset = function recipientLinkSurveyAndRecipientResponseReset(data) {
  return {
    type: _recipient.actionTypes.LINK_SURVEY_AND_RECIPIENT_RESPONSE_RESET,
    payload: data
  };
};

/**
 * Link Single Soft Delete
 * @param payload
 * @returns api response
 * @description this function used to Link Single Soft Delete.
 */
exports.recipientLinkSurveyAndRecipientResponseReset = recipientLinkSurveyAndRecipientResponseReset;
var recipientLinkSingleSoftDelete = function recipientLinkSingleSoftDelete(data) {
  return {
    type: _recipient.actionTypes.LINK_SINGLE_SOFT_DELETE,
    payload: data
  };
};

/**
 * Link Single Soft Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Link Single Soft Delete Bulk.
 */
exports.recipientLinkSingleSoftDelete = recipientLinkSingleSoftDelete;
var recipientLinkSingleSoftDeleteBulk = function recipientLinkSingleSoftDeleteBulk(data) {
  return {
    type: _recipient.actionTypes.LINK_SINGLE_SOFT_DELETE_BULK,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
exports.recipientLinkSingleSoftDeleteBulk = recipientLinkSingleSoftDeleteBulk;
var recipientStatusUnpagedList = function recipientStatusUnpagedList(data) {
  return {
    type: _recipient.actionTypes.LIST_UNPAGED,
    payload: data
  };
};

// Response
/**
 * Survey Configuration Fetch Response
 * @param payload
 * @returns api response
 * @description this function used to fetch survey configuration response.
 */
exports.recipientStatusUnpagedList = recipientStatusUnpagedList;
var surveyConfigurationFetchResponse = function surveyConfigurationFetchResponse(data) {
  return {
    type: _recipient.actionTypes.SURVEY_CONFIGURATION_FETCH_RESPONSE,
    payload: data
  };
};

/**
 * Survey Configuration Fetch Response Reset
 * @param payload
 * @returns api response
 * @description this function used to reset survey configuration fetch response.
 */
exports.surveyConfigurationFetchResponse = surveyConfigurationFetchResponse;
var surveyConfigurationFetchResponseReset = function surveyConfigurationFetchResponseReset(data) {
  return {
    type: _recipient.actionTypes.SURVEY_CONFIGURATION_FETCH_RESPONSE_RESET,
    payload: data
  };
};
exports.surveyConfigurationFetchResponseReset = surveyConfigurationFetchResponseReset;